import { Avatar, Container } from "@material-ui/core"
import { styles } from "../helpers";
import esFlag from './../images/es_flag.png';
import ukFlag from './../images/uk_flag.png';

import { makeStyles } from "@material-ui/core/styles";


const useStyles = makeStyles((theme) => {
    return styles;
});



const LanguageSelector = (props) => {

    const setLanguage = props.setLanguage;
    const classes = useStyles();

    const handleFlagClick = (lang) => setLanguage(lang);

    return (
        <Container className={classes.languageSelectorContainer}>
            <Avatar className={classes.flagIcon} 
            src={esFlag} 
            alt="Seleccionar lenguaje castellano"
            onClick={() => handleFlagClick("es_ES")}/>
            <Avatar className={classes.flagIcon} 
            src={ukFlag} 
            alt="Seleccionar lenguaje inglés"
            onClick={() => handleFlagClick("en_UK")}/>
        </Container>
    )
}

export default LanguageSelector;